var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwygsMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5217 23.4575C22.5217 24.1997 22.7342 24.7827 23.1545 25.2006C23.5796 25.6155 24.131 25.823 24.8165 25.823C25.761 25.823 26.5904 25.6024 27.308 25.1538L29.9432 32.1656C28.286 33.0248 26.0199 33.4573 23.1561 33.4573C19.4134 33.4573 16.5337 32.6347 14.5137 30.9821C12.4937 29.3296 11.4869 26.8501 11.4869 23.548V19.9932C11.4869 17.6963 13.5229 15.8349 16.0351 15.8349H19.5381C20.6791 15.8349 21.7195 15.4272 22.4865 14.761C22.5121 14.7376 22.5409 14.7113 22.5712 14.6879C23.3463 13.9749 23.8257 12.9989 23.8257 11.9147C23.8257 10.8306 23.3096 9.77715 22.4865 9.0612C21.7179 8.39494 20.6791 7.99022 19.5381 7.99022H16.0351C13.5229 7.99022 11.4869 6.12877 11.4869 3.83191V0.542969H22.4865V3.1788C22.4865 5.83509 24.8389 7.99022 27.749 7.99022C28.9268 7.99022 30.0327 8.43147 30.8413 9.14156C31.6531 9.8502 32.1661 10.8306 32.1693 11.9089C32.1693 12.996 31.6899 13.9764 30.9068 14.6894C30.135 15.398 29.0595 15.8363 27.8737 15.8363H27.8145C24.906 15.8363 22.5521 17.9915 22.5521 20.6478L22.5233 23.4589L22.5217 23.4575Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38026 15.9359C10.8215 15.9359 12.8006 14.1265 12.8006 11.8944C12.8006 9.66243 10.8215 7.85303 8.38026 7.85303C5.93899 7.85303 3.95996 9.66243 3.95996 11.8944C3.95996 14.1265 5.93899 15.9359 8.38026 15.9359Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwygsMobileLogo);
export default __webpack_public_path__ + "static/media/twygs-mobile-logo.d69e23044f1b4eb60d04119e5f374c3e.svg";
export { ForwardRef as ReactComponent };